import { project } from "@arcgis/core/geometry/projection";
import { createSlice } from "@reduxjs/toolkit";

export const initialState = 
{
  viewingActions: true,
  viewingProjects: false
}

export const menuSlice = createSlice({
  name: 'menu',
  initialState,
  reducers: {
    setViewingActions: (state, action) => {
      state.viewingActions = action.payload;
    },
    setViewingProjects: (state, action) => {
      state.viewingProjects = action.payload;
    }
  }
});

export const {setViewingActions, setViewingProjects} = menuSlice.actions;

export default menuSlice.reducer;